import { useHomeBanner, useServiceAISpeckingCoach } from '@/src/api/getData';
import Banner from '@/components/banner';
import Video from '@/components/video';
import Card from '@/components/card';

const ITechSpeakingCoachView: any = ({ language = '' }) => {
    const { data: banner } = useHomeBanner(language);
    const { data: speakingCoach } = useServiceAISpeckingCoach(language);

    let speakingCoachData = speakingCoach?.data || [];
    let cards = speakingCoachData?.Cards || [];
    let content = speakingCoachData?.Content || {};

    console.log(speakingCoachData);


    return (
        <main className='bg-2' id="start">
            <Banner banner={banner} category="AI Speaking Coach" />
            <Card cardData={cards} cardType="orange-card"/>
            {content && Array.isArray(content) && content.map((item: any, index: number) => {
                if (item.__component === "components.editor") {
                    return <section className="gradientCard container">
                        <div className="gradientCard-content">
                            <div className="pattern"></div>
                            <div className="content">
                                <div className='lists lists-v2'><div dangerouslySetInnerHTML={{ __html: item.Editor }} />
                                </div>
                            </div>
                        </div>
                    </section>
                } else if (item.__component === "components.video") {
                    return <Video key={index} videoData={item.Video} />;
                }
                return null;
            })}
        </main >
    );
}

export default ITechSpeakingCoachView;